<template>
  <div class="enter_form">
    <el-form label-position="top">
      <el-row type="flex" justify="space-between" class="container">
        <el-col class="block">
          <p class="title">上传法人证件</p>
          <el-form-item label="法人姓名" required>
            <el-input placeholder="请输入法人姓名"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证类型" required>
            <el-select v-model="value" clearable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人身份证号" required>
            <el-input placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证有效期" required>
            <el-row type="flex" justify="space-between">
              <el-col>
                <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
              </el-col>
              <el-col class="middle">
                <span>至</span>
              </el-col>
              <el-col>
                <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col class="block between">
          <div>
            <p class="title">上传营业执照</p>
            <el-form-item label="营业执照号" required>
              <el-input placeholder="营业执照号"></el-input>
            </el-form-item>
            <el-form-item required>
              <span slot="label">
                <span>营业期限</span>
                <el-checkbox v-model="form.check" @change="changeDate" class="suffix">长期</el-checkbox>
              </span>
              <el-row type="flex" justify="space-between">
                <el-col>
                  <el-date-picker v-model="form.credentials.start" type="date" placeholder="选择日期"></el-date-picker>
                </el-col>
                <el-col class="middle">
                  <span>至</span>
                </el-col>
                <el-col>
                  <el-date-picker
                    v-model="form.credentials.end"
                    type="date"
                    placeholder="选择日期"
                    :disabled="form.check"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div>
            <p class="title">上传相关证件</p>
            <el-form-item required>
              <span slot="label">
                <span>证件期限</span>
                <el-checkbox v-model="form.check" class="suffix">长期</el-checkbox>
              </span>
              <el-row type="flex" justify="space-between">
                <el-col>
                  <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
                </el-col>
                <el-col class="middle">
                  <span>至</span>
                </el-col>
                <el-col>
                  <el-date-picker
                    v-model="value"
                    type="date"
                    placeholder="选择日期"
                    :disabled="form.check"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </el-col>
        <el-col class="block append">
          <p class="title">上传相关证件</p>
          <el-form-item required>
            <span slot="label">
              <span>证件期限</span>
              <el-checkbox v-model="form.check" class="suffix">长期</el-checkbox>
            </span>
            <el-row type="flex" justify="space-between">
              <el-col>
                <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
              </el-col>
              <el-col class="middle">
                <span>至</span>
              </el-col>
              <el-col>
                <el-date-picker
                  v-model="value"
                  type="date"
                  placeholder="选择日期"
                  :disabled="form.check"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col class="block append">
          <p class="title">上传相关证件</p>
          <el-form-item required>
            <span slot="label">
              <span>证件期限</span>
              <el-checkbox v-model="form.check" class="suffix">长期</el-checkbox>
            </span>
            <el-row type="flex" justify="space-between">
              <el-col>
                <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
              </el-col>
              <el-col class="middle">
                <span>至</span>
              </el-col>
              <el-col>
                <el-date-picker
                  v-model="value"
                  type="date"
                  placeholder="选择日期"
                  :disabled="form.check"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col class="block full append">
          <p class="title">上传相关照片</p>
          <p class="title-tip">单张上传，支持png、jpg</p>
          <div class="upload">
            <upload v-model="fileeg"></upload>
            <upload v-model="file1"></upload>
            <upload v-model="file2" v-for="a of list" :key="a"></upload>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="37" justify="center" class="btn-submit">
        <el-col>
          <el-button @click="prev" type="danger">上一步，填写店铺信息</el-button>
        </el-col>
        <el-col>
          <el-button @click="commit" type="info">确认信息，立即提交</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import upload from "./upload";

export default {
  model: {
    prop: "form"
  },
  props: {
    form: Object
  },
  data() {
    return {
      options: [],
      value: "",
      fileeg: {
        name: "示例",
        file: {
          url: "http://pic1.win4000.com/pic/4/8c/bac093c5d9.png"
        },
        disabled: true
      },
      file1: {
        name: "法人证件照"
      },
      file2: {
        name: "营业执照"
      },
      list: [1, 2, 3, 4]
    };
  },
  components: {
    upload
  },
  methods: {
    prev() {
      this.form.step = 2;
      this.$emit("update:form", this.form);
    },
    commit() {
      console.log(this.form);
    },
    changeDate(check) {
      if (check) {
        delete this.form.credentials.end;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.enter_form {
  width: 882px;

  .container {
    flex-wrap: wrap;
  }

  /deep/ .block {
    width: 417px;

    .title {
      color: #333;
      font-size: 20px;
      margin-bottom: 5px;

      &-tip {
        color: #999;
        font-size: 14px;
      }
    }

    &.between {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &.append {
      margin-top: 48px;
    }
    &.full {
      width: 100%;

      .upload {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  .el-form {
    .el-form-item {
      .middle {
        width: auto;
        padding: 0 15px !important;
        display: flex;

        span {
          margin: auto;
        }
      }
      .el-row {
        width: 100%;
      }
      .el-select {
        width: 100%;
      }
    }
  }
  .btn-submit {
    margin-top: 40px;

    .el-col {
      width: 350px;
    }
    /deep/ .el-button--danger {
      background-color: #fff;
      border-color: #eb1b29;
      span {
        color: #eb1b29;
      }
    }
    /deep/ .el-button--info {
      background-color: #d9d9d9;
      border: none;
    }
  }
}
</style>